import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { actionCreators as modelActionCreators } from '../../store/Model'
import { actionCreators as GlobalStoreCreator } from '../../store/General'
import { applyConditions } from '../../utils/dcmUtils'
import { getMeta } from '../../utils/metaUtils'
import { ToggleSwitch } from '../common/ToggleSwitch'
import { AttributeBox } from './AttributeBox'

import { debounce } from '../../utils/debounce'
import { AttributeBoxFordU833 } from './AttributeBoxFordU833'

export const EditAreaAttsU833 = (props) => {
  // console.log("EditAreaAtts2.props", props);
  const { area, prodId, configModel, monitor_atts, usePriceAtts } = props
  //  console.log('prodId::::::::', prodId);
  //  console.log('configModel', configModel);
  //  console.log('monitor_atts', monitor_atts);

  const { study, auth, model, general } = useSelector((state) => ({
    study: state.study,
    auth: state.auth,
    model: state.model,
    general: state.general,
  }))

  const dispatch = useDispatch()
  const cfgModel = model?.[configModel]
  const play = (cfgModel || {}).config?.play
  const use_price_atts = usePriceAtts || false

  // Fallback to first product if prodId is not provided
  const prod =
    play?.find((s) => s.uid === prodId) || (play?.length > 0 ? play[0] : null)

  const [label, setLabel] = useState(prod?.label)
  const [meta, setMeta] = useState(null)
  const [metaLookups, setMetaLookups] = useState(null)

  const debouncedSetLabel = debounce(
    (productUid, label) =>
      dispatch(modelActionCreators.setProductLabel(productUid, label)),
    2000
  )

  useEffect(() => {
    if (prod) {
      setLabel(prod.label)
    }
  }, [prod])

  useEffect(() => {
    const fetchMetaData = async () => {
      // Guard: skip entirely if critical data is missing
      if (!study?.uid || !auth) {
        console.warn('fetchMetaData skipped: missing study.uid or auth');
        setMeta(null);
        setMetaLookups(null);
        return;
      }

      // First fetch: attConditionsTable
      const tableKey = cfgModel?.modelInfo?.attConditionsTable;
      if (tableKey && typeof tableKey === 'string' && tableKey.trim() !== '') {
        try {
          console.log('Fetching meta for attConditionsTable:', tableKey);
          const m = await getMeta(study.uid, auth, tableKey);
          if (m) {
            setMeta(m);
          } else {
            console.warn('getMeta returned no data for attConditionsTable');
            setMeta(null);
          }
        } catch (err) {
          console.warn('getMeta failed for attConditionsTable:', err);
          setMeta(null);
        }
      } else {
        console.log('Skipping getMeta - no valid attConditionsTable key');
        setMeta(null);
      }

      // Second fetch: attConditionsLookups (array of keys)
      const lookupKeys = cfgModel?.modelInfo?.attConditionsLookups;
      if (Array.isArray(lookupKeys) && lookupKeys.length > 0) {
        try {
          console.log('Fetching meta lookups:', lookupKeys);
          const lookups = await getMeta(study.uid, auth, lookupKeys);
          if (lookups) {
            setMetaLookups(lookups);
          } else {
            console.warn('getMeta returned no data for attConditionsLookups');
            setMetaLookups(null);
          }
        } catch (err) {
          console.warn('getMeta failed for attConditionsLookups:', err);
          setMetaLookups(null);
        }
      } else {
        console.log('Skipping getMeta lookups - empty or missing list');
        setMetaLookups(null);
      }
    };

    fetchMetaData();

    // Dependencies: only re-run when these values actually change
  }, [study?.uid, auth, cfgModel?.modelInfo?.attConditionsTable, cfgModel?.modelInfo?.attConditionsLookups]);

  //  console.log('metaLookups',metaLookups);

  if (!configModel) {
    console.log('configModel missing, returning null')
    return null
  }
  if (!prod) {
    console.log(
      'EditAreaAttsP833: No product found. prodId:',
      prodId,
      'play:',
      play
    )
    return null
  }

  const productDefSource = cfgModel?.config?.productDef
  // console.log('productDefSource', productDefSource)
  if (!productDefSource) {
    console.log('productDefSource missing, returning null')
    return null
  }
  const productDef = JSON.parse(JSON.stringify(productDefSource))

  //set readOnly atts
  const updatedAtts = applyConditions(
    prod,
    productDef?.atts,
    meta?.rules,
    metaLookups
  )

  const editAtts = updatedAtts
    .filter((att) => !att.readOnly)
    // .filter(att => att.area === area)
    .sort((a, b) => a.displayIndex - b.displayIndex)
    .filter((att) => (att.showIf ? att.showIf(play) : true))

  const handleToggle = (newVal) => {
    // console.log('newval', newVal);
    dispatch(modelActionCreators.setAvailable(prod?.uid, newVal, configModel))
    dispatch(
      GlobalStoreCreator.setGlobalStore(
        'forecast_needed',
        newVal ? true : false
      )
    )
  }

  return (
    <div className="att-area-editor">
      {/* {prod?.cloneOf && (
        <div className='atts-container no-pad'>
          <div className='attribute-box'>
            <div className='title'>
              <label>{productLabel} Name:</label>
              <span 
                className='del-product-btn'
                role='button' 
                aria-label='delete'
                onClick={() => modelActionCreators.deleteProduct(prod?.uid)}
              >
                Delete
              </span>
            </div>

            <input
              type="text"
              className="edit-product-label"
              value={label}
              onChange={handleLabelChange} 
            />
          </div>
        </div>
      )} */}

      {/* <div className="availability-section">
        <ToggleSwitch
          className="mini"
          on={Boolean(prod?.available)}
          onChange={handleToggle}
        >
          Available in Market
        </ToggleSwitch>
      </div> */}

      {Boolean(prod?.available) && (
        <div className="atts-container">
          {editAtts
            .filter((f) => f.type !== 'string')
            .sort((a, b) => {
              if (!use_price_atts) return 0
              const isBasePriceAttA = a.name === 'base'
              const isBasePriceAttB = b.name === 'base'
              return isBasePriceAttA ? -1 : isBasePriceAttB ? 1 : 0
            })
            .map((att) => {
              return (
                <AttributeBoxFordU833
                  key={att.name}
                  prod={prod}
                  att={att}
                  configModel={configModel}
                  monitor_atts={monitor_atts}
                />
              )
            })}
        </div>
      )}
    </div>
  )
}